import * as THREE from 'three'
import ReactDOM from 'react-dom'
import React, { Suspense, useState } from 'react'
import { Canvas, useLoader } from '@react-three/fiber'
import { Html, Preload, OrbitControls } from '@react-three/drei'
import { Popconfirm } from 'antd'
import 'antd/dist/antd.css'
import './styles.css'

const store = [
  { name: 'Visit Abdoun', color: 'lightpink', position: [10, 0, -15], url: '/1.jpg', link: 1 },
  { name: 'Visit Wadi Rum', color: 'lightblue', position: [15, 0, 0], url: '/2.jpg', link: 0 }
  // ...
]

function Dome({ name, position, texture, onClick }) {
  return (
    <group>
      <mesh>
        <sphereBufferGeometry args={[500, 60, 40]} />
        <meshBasicMaterial map={texture} side={THREE.BackSide} />
      </mesh>
      <mesh position={position}>
        <sphereGeometry args={[1.25, 32, 32]} />
        <meshBasicMaterial color="white" />
        <Html center>
          <Popconfirm title="Are you sure you want to visit this site?" onConfirm={onClick} okText="Yes" cancelText="No">
            <a href="#">{name}</a>
          </Popconfirm>
        </Html>
      </mesh>
    </group>
  )
}

function Portals() {
  const [which, set] = useState(0)
  const { link, ...props } = store[which]
  const maps = useLoader(THREE.TextureLoader, store.map((entry) => entry.url)) // prettier-ignore
  return <Dome onClick={() => set(link)} {...props} texture={maps[which]} />
}

ReactDOM.render(
  <Canvas frameloop="demand" camera={{ position: [0, 0, 0.1] }}>
    <OrbitControls enableZoom={false} enablePan={false} enableDamping dampingFactor={0.2} autoRotate={false} rotateSpeed={-0.5} />
    <Suspense fallback={null}>
      <Preload all />
      <Portals />
    </Suspense>
  </Canvas>,
  document.getElementById('root')
)
